/* La Roda: contact intent only; never infer a completed reservation. */
(() => {
  'use strict';
  const config = document.getElementById('lr-measurement');
  if (!config || config.dataset.ready === 'true') return;
  config.dataset.ready = 'true';
  const live = config.dataset.mode === 'live';
  const language = ['es', 'ca', 'en', 'fr', 'it', 'de'].includes(config.dataset.language)
    ? config.dataset.language : 'es';
  const pageTypes = {
    '/': 'home', '/pages/espanol-catala': 'menu',
    '/pages/english-francaise': 'menu', '/pages/english-francais': 'menu',
    '/pages/alergenos-al-lergens': 'allergens', '/pages/menu-grupos': 'groups',
    '/pages/menu-fiestas': 'holidays', '/pages/contact': 'reservations',
    '/pages/como-llegar': 'directions', '/pages/sobre-nosotros': 'gallery',
    '/pages/solicitar-factura': 'invoice'
  };
  const cleanPath = path => path.replace(/^\/(?:es|ca|en|fr|it|de)(?=\/|$)/, '').replace(/\/$/, '') || '/';
  const pageType = pageTypes[cleanPath(location.pathname)] || 'other';
  const holidayMenus = { 'navidad': 'christmas', 'sant-esteve': 'sant_esteve',
    'fin-de-ano': 'new_years_eve', 'ano-nuevo': 'new_year', 'reyes': 'epiphany' };
  const groupMenus = { '29.95': 'group_29_95', '39.95': 'group_39_95', '49.95': 'group_49_95' };
  let lastSignature = '';
  let lastAt = 0;
  function allowed() {
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; }
    catch (_) { return false; }
  }
  function emit(eventName, placement, menuOption = 'none') {
    const data = { event_name: eventName, page_type: pageType, site_language: language,
      placement, menu_option: menuOption, environment: live ? 'live' : 'preview' };
    const signature = JSON.stringify(data);
    const now = Date.now();
    if (signature === lastSignature && now - lastAt < 700) return;
    lastSignature = signature;
    lastAt = now;
    // Preview diagnostics contain fixed labels only, never URLs or form content.
    if (!live) {
      config.dataset.lastEvent = signature;
      config.dataset.eventCount = String(Number(config.dataset.eventCount || 0) + 1);
      return;
    }
    if (!allowed() || typeof window.Shopify?.analytics?.publish !== 'function') return;
    try {
      const pending = window.Shopify.analytics.publish('la_roda:business_event', data);
      if (pending && typeof pending.catch === 'function') pending.catch(() => {});
    } catch (_) { /* Measurement must never block contact or navigation. */ }
  }
  function placementFor(link, path) {
    if (path.some(node => node?.tagName === 'GTY-WHATSAPP-CHAT-BUTTON')) return 'floating';
    if (link.closest('footer')) return 'footer';
    if (link.closest('header, .shopify-section-header')) return 'header';
    if (link.closest('.announcement-bar')) return 'announcement';
    return 'content';
  }
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button > 0) return;
    const path = event.composedPath();
    const link = path.find(node => node?.tagName === 'A' && node.hasAttribute('href'));
    if (!link) return;
    let url;
    try { url = new URL(link.href, location.origin); } catch (_) { return; }
    const placement = placementFor(link, path);
    if (url.hostname === 'wa.me' || url.hostname === 'api.whatsapp.com') {
      const groupForm = link.closest('.lr-group-inquiry-form');
      if (groupForm) {
        if (!groupForm.checkValidity()) return;
        const option = groupForm.elements.menu?.value;
        emit('lr_group_inquiry', placement, groupMenus[option] || 'undecided');
      } else if (pageType === 'holidays' && link.closest('.lr6-menu')) {
        emit('lr_holiday_inquiry', placement, holidayMenus[link.closest('.lr6-menu').dataset.menu] || 'none');
      } else emit('lr_whatsapp_click', placement);
      return;
    }
    if (url.protocol === 'tel:') return emit('lr_phone_click', placement);
    if (url.protocol === 'mailto:') return emit('lr_email_click', placement);
    if ((url.hostname === 'www.google.com' && url.pathname.startsWith('/maps')) || url.hostname === 'maps.app.goo.gl') {
      return emit('lr_directions_click', placement);
    }
    if (url.origin !== location.origin) return;
    const destination = pageTypes[cleanPath(url.pathname)];
    if (destination === 'reservations' && cleanPath(url.pathname) !== cleanPath(location.pathname)) {
      emit('lr_reservation_open', placement);
    } else if (destination === 'menu' && cleanPath(url.pathname) !== cleanPath(location.pathname)) {
      emit('lr_menu_open', placement);
    }
  }, { capture: true });
  let widgetObserved = false;
  function observeWidget() {
    if (widgetObserved || !('IntersectionObserver' in window)) return;
    const widget = document.querySelector('iframe[src^="https://widget.thefork.com/"]');
    if (!widget) return;
    widgetObserved = true;
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) {
        emit('lr_booking_widget_view', 'content');
        observer.disconnect();
      }
    }, { threshold: 0.1 });
    observer.observe(widget);
  }
  let contentViewed = false;
  function initialise() {
    if (live && !allowed()) return;
    if (!contentViewed && ['menu', 'groups', 'holidays', 'reservations'].includes(pageType)) {
      contentViewed = true;
      emit('lr_content_view', 'page');
    }
    observeWidget();
  }
  // Only read the existing consent; never change a visitor's choice.
  if (live && !window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], error => {
      if (!error) initialise();
    });
  } else initialise();
  document.addEventListener('visitorConsentCollected', initialise);
  document.addEventListener('shopify:section:load', observeWidget);
})();
